import { Inject, Injectable, InjectionToken } from "@angular/core";
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from "@angular/common/http";
import {
  catchError,
  finalize,
  Observable,
  throwError,
  timeout,
  TimeoutError,
} from "rxjs";
import { AuthService } from "./core/services/auth.service";
import { environment } from "environments/environment";
import { LoadingIndicatorService } from "./loading-indicator-service";
import { UtilsModalsService } from "./core/services/helpers/utils-modal.service";
import { AlertService } from "./core/services/alert.service";

export const DEFAULT_TIMEOUT = new InjectionToken<number>("defaultTimeout");

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(
    private utilsModalsService: UtilsModalsService,
    private loadingIndicatorService: LoadingIndicatorService,
    private authService: AuthService,
    public alertService: AlertService,
    @Inject(DEFAULT_TIMEOUT) protected defaultTimeout: number
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    request = this.addTokenToRequest(request);
    const modified = request.clone({
      setHeaders: { "X-Request-Timeout": `${this.defaultTimeout}` },
    });
    // emit onStarted event before request execution
    this.loadingIndicatorService.onStarted(modified);
    // window.scroll({ top: 0, left: 0, behavior: "smooth" });

    return next.handle(modified).pipe(
      timeout(this.defaultTimeout),
      finalize(() => {
        this.loadingIndicatorService.onFinished(modified);
      }),
      catchError((error) => {
        const errorPayload =
          error?.error && typeof error.error === "object" ? error.error : null;

        if (error instanceof TimeoutError) {
          this.utilsModalsService.showModalTimeoutRedirect(
            error.message,
            modified
          );
        }
        if (errorPayload?.statusCode && errorPayload.statusCode !== 400) {
          this.utilsModalsService.showModalErrorRedirect(errorPayload);
        }
        return throwError(() => error);
      })
    );
  }

  private addTokenToRequest(request: HttpRequest<any>) {
    let token = AuthService.getFromStorage(environment.storageTokenNameApi);
    let currentLang = AuthService.getFromStorage(
      environment.storageLanguageNameApi
    );

    if (currentLang) {
      if (currentLang != "es" && currentLang != "en") {
        currentLang = "en";
      }
    } else {
      currentLang = "en";
    }
    this.authService.saveLocalStorage(
      environment.storageLanguageNameApi,
      currentLang
    );

    if (token == null) token = "0";
    request = request.clone({
      // withCredentials: true,
      headers: request.headers.set("Accept-Language", currentLang),
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
    return request;
  }
}
